<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
        >下载</el-button
        >
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="total, prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
          ref="dataTable"
          :data="advs"
          style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期">
          <template scope="scope">
            {{ scope.row.crawler_version }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>

        <el-table-column prop="authorDouId" label="基本信息">
          <template scope="scope">
            店铺ID:{{ scope.row.poi_id }} <br />
            店铺名称: <a :href="scope.row.poi_url">{{ scope.row.poi_name }}</a> <br />
            {{scope.row.entry_prefix}} : {{scope.row.entry_title}}
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="地址/联系方式">
          <template scope="scope">
            详细地址:{{ scope.row.addr_with_extra_info }} <br />
            联系电话: {{ scope.row.telephone }} <br />
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="地址和联系方式">
          <template scope="scope">

            账户ID:{{ scope.row.account_id }} <br />
            账户昵称: <a :href="scope.row.account_url"> {{ scope.row.account_name }} </a> <br />
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
// const _ = require("lodash");
export default {
  name: "searchSiteAdvInfo",
  data() {
    return {
      advs: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }


      window.open("/api/douyin/group_mall/exportMallDetails?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }


      axios
          .get("/api/douyin/group_mall/queryPagedDetails?currentPage=" + pageNum + "&pageSize=50" + para)
          .then((content) => {
            if (content.data.status === 0) {
              console.log(content.data.data)
              _this.advs = content.data.data;
              _this.totalItems = content.data.total;
            }
          });
    },
  },
  mounted() {
    this.loadItemInfo(1);
  },
};
</script>
